angular
    .module('festzelt-os.auth')
    .config([
        '$authProvider',
        'Env',
        config
    ]);

function config($authProvider, Env) {
    $authProvider.baseUrl = Env.apiUrl;
    $authProvider.signupUrl = 'auth/register';
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/auth-provider.js